import { api } from "./api";

export const systemApi = {
  status: () => api.get("/system/status").then((r) => r.data),
  getDemoMode: () => api.get("/system/demo-mode").then((r) => r.data),
  setDemoMode: (demo_mode) =>
    api.post("/system/demo-mode", { demo_mode }).then((r) => r.data),
  health: () => api.get("/system/health").then((r) => r.data),
};
